import { Building2, Check } from 'lucide-react';

// Multi-shop pill filter. Defaults to all selected; clicking a pill
// toggles. "All / None" buttons for quick reset.
export default function ShopFilter({ shops, selectedIds, onChange }) {
  const all = shops.map((s) => s.shop_id);
  const allSelected = selectedIds.length === all.length && all.length > 0;

  const toggle = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((x) => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[1px] font-bold text-[var(--color-warm-500)]">
        <Building2 size={13} />
        Shops
      </div>

      <div className="inline-flex items-center gap-1.5 flex-wrap">
        {shops.map((s) => {
          const active = selectedIds.includes(s.shop_id);
          return (
            <button
              key={s.shop_id}
              type="button"
              onClick={() => toggle(s.shop_id)}
              className={`
                inline-flex items-center gap-1.5 h-7 px-2.5 text-[12px] font-semibold rounded-[var(--radius-full)]
                border transition-all
                ${active
                  ? 'bg-[var(--color-recovery-50)] text-[var(--color-recovery-700)] border-[var(--color-recovery-300)]'
                  : 'bg-[var(--color-cream-50)] text-[var(--color-warm-600)] border-[var(--color-warm-200)] hover:border-[var(--color-warm-300)]'}
              `}
            >
              {active && <Check size={11} className="text-[var(--color-recovery-600)]" />}
              {s.shop_name || `Shop ${s.shop_id}`}
            </button>
          );
        })}
      </div>

      {/* All / None */}
      <div className="inline-flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onChange(all)}
          disabled={allSelected}
          className="text-[11px] text-[var(--color-warm-500)] hover:text-[var(--color-warm-800)] underline underline-offset-2 disabled:opacity-40 disabled:no-underline"
        >
          All
        </button>
        <span className="text-[var(--color-warm-300)]">·</span>
        <button
          type="button"
          onClick={() => onChange([])}
          disabled={selectedIds.length === 0}
          className="text-[11px] text-[var(--color-warm-500)] hover:text-[var(--color-warm-800)] underline underline-offset-2 disabled:opacity-40 disabled:no-underline"
        >
          None
        </button>
      </div>
    </div>
  );
}
